import React, { createContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";

interface AuthContextProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  loginWithRedirect: () => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, isLoading, loginWithRedirect }}
    >
      {children}
    </AuthContext.Provider>
  );
};
